/**
 * The empty/no-results card states for the Operations Add Team modal.
 *
 * Mirrors the roster Add Player card (`playerSearchCardState`) but takes no
 * minimum-length threshold: the legacy team search browses page 1 of the
 * organization before anything is typed, so there is no "idle, keep typing"
 * state — an empty query is a real search with real results.
 */
export type TeamSearchCardState = 'searching' | 'empty' | 'hidden'

interface Params {
  isSearching: boolean
  resultCount: number
}

export const getTeamSearchCardState = ({
  isSearching,
  resultCount,
}: Params): TeamSearchCardState => {
  // Results already on screen win over a background refetch, so paging or
  // re-querying does not blank the list behind a "Searching..." card.
  if (resultCount > 0) {
    return 'hidden'
  }
  return isSearching ? 'searching' : 'empty'
}
